import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { ShareButtons } from "../../../components/ShareButtons";
import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { Modal } from "../../../components/Modal";

import {
  Screen1,
  Result,
  Info,
  Tech,
  School,
  Edu,
  Cases,
  VidReviews
} from "../../../components/LandingTemplates/about";

import * as screen1 from "./styles/screen1top.module.scss";
import * as offers from "./styles/offers.module.scss";
const Screen1Top = () => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <h2>ВСЕ МАТЕРИАЛЫ</h2>
        <h3>для успешного обучения и мотивации</h3>
        <div className={screen1.wrap}>
          <a href="#teens" className={screen1.item}>
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/allmaterials-kids.png" alt=""/>
            <p>Школьники и студенты</p>
          </a>
          <a href="#adult" className={screen1.item}>
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/allmaterials-adult.png" alt=""/>
            <p>Взрослые</p>
          </a>
          <a href="#english" className={screen1.item}>
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/allmaterials-english.png" alt=""/>
            <p>Английский язык</p>
          </a>
        </div>
        <div className={screen1.share}>
          <h4>Поделиться бесплатными материалами с близкими</h4>
          <ShareButtons/>
        </div>
      </div>
    </section>
  );
};
const Teens = (
  {
    widgetVocabulary,
    widgetGrammar,
    widgetMarathon
  }
) => {
  const [showModalVocabulary, setShowModalVocabulary] = React.useState(false);
  const [showModalGrammar, setShowModalGrammar] = React.useState(false);
  const [showModalMarathon, setShowModalMarathon] = React.useState(false);
  return (
    <section className={`${offers.offers} ${offers.teens}`} id="teens">
      <div className="container">
        <h2>Для школьников, студентов и их родителей</h2>
        <div className={offers.wrap}>
          <div
            className={offers.card}
            onClick={()=>{setShowModalVocabulary(true)}}
            onKeyDown={()=>{setShowModalVocabulary(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/kids-leksika.png" alt=""/>
            <div className={offers.info}>
              <h3>Английская лексика для детей</h3>
              <p>5–7 класс. Курс научит получать удовольствие от изучения английского языка</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalGrammar(true)}}
            onKeyDown={()=>{setShowModalGrammar(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/kids-grammatika.png" alt=""/>
            <div className={offers.info}>
              <h3>Английская грамматика для детей</h3>
              <p>5–7 класс. Бесплатный курс, построенный на игровом сценарии, поможет изучить основные грамматические правила английского языка</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalMarathon(true)}}
            onKeyDown={()=>{setShowModalMarathon(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/kids-maraphon.png" alt=""/>
            <div className={offers.info}>
              <h3>Марафон мотивации и обучения детей</h3>
              <p>Пробудите у ребёнка интерес к учёбе, желание побеждать и дайте возможность легче и быстрее учиться в школе</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModalVocabulary}
        onClose={() => {
          setShowModalVocabulary(false);
        }}
      >
        { widgetVocabulary }
      </Modal>
      <Modal
        open={showModalGrammar}
        onClose={() => {
          setShowModalGrammar(false);
        }}
      >
        { widgetGrammar }
      </Modal>
      <Modal
        open={showModalMarathon}
        onClose={() => {
          setShowModalMarathon(false);
        }}
      >
        { widgetMarathon }
      </Modal>
    </section>
  );
};
const Adults = (
  {
    widgetWorkout,
    widgetMnemo,
    widgetSmart,
    widgetMarathon,
    widgetEverydayTraining
  }
) => {
  const [showModalWorkout, setShowModalWorkout] = React.useState(false);
  const [showModalMnemo, setShowModalMnemo] = React.useState(false);
  const [showModalSmart, setShowModalSmart] = React.useState(false);
  const [showModalMarathon, setShowModalMarathon] = React.useState(false);
  const [showModalEverydayTraining, setShowModalEverydayTraining] = React.useState(false);
  return (
    <section className={offers.offers}  id="adult">
      <div className="container">
        <h2>Тонус мозга и интеллектуальная выносливость</h2>
        <div className={offers.wrap}>
          <div
            className={offers.card}
            onClick={()=>{setShowModalWorkout(true)}}
            onKeyDown={()=>{setShowModalWorkout(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/adult-zaryadka.png" alt=""/>
            <div className={offers.info}>
              <h3>Зарядка для мозга</h3>
              <p>Приведи свой мозг в тонус за 3 дня</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalMnemo(true)}}
            onKeyDown={()=>{setShowModalMnemo(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/adult-mnemo.png" alt=""/>
            <div className={offers.info}>
              <h3>Экспресс-курс по мнемотехнике</h3>
              <p>Перестать забывать даже раз услышанное</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalSmart(true)}}
            onKeyDown={()=>{setShowModalSmart(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/adult-smart.png" alt=""/>
            <div className={offers.info}>
              <h3>Целеполагание по SMART</h3>
              <p>Для тех, кто хочет достигать своих целей</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <button className={offers.card} onClick={()=>{setShowModalMarathon(true)}}>
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/adult-imaraphon.png" alt=""/>
            <div className={offers.info}>
              <h3>Интеллектуальный марафон: приведи свой мозг в тонус!</h3>
              <span>Получить бесплатно</span>
            </div>
          </button>
          <div
            className={offers.card}
            onClick={()=>{setShowModalEverydayTraining(true)}}
            onKeyDown={()=>{setShowModalEverydayTraining(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/adult-everyday-training.jpg" alt=""/>
            <div className={offers.info}>
              <h3>Ежедневные тренировки в телеграм-канале</h3>
              <p>Конкретные инструменты повышения интеллектуальной выносливости, чтобы ее с запасом хватало на интенсивный рабочий день!</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModalWorkout}
        onClose={() => {
          setShowModalWorkout(false);
        }}
      >
        { widgetWorkout }
      </Modal>
      <Modal
        open={showModalMnemo}
        onClose={() => {
          setShowModalMnemo(false);
        }}
      >
        { widgetMnemo }
      </Modal>
      <Modal
        open={showModalSmart}
        onClose={() => {
          setShowModalSmart(false);
        }}
      >
        { widgetSmart }
      </Modal>
      <Modal
        open={showModalMarathon}
        onClose={() => {
          setShowModalMarathon(false);
        }}
      >
        { widgetMarathon }
      </Modal>
      <Modal
        open={showModalEverydayTraining}
        onClose={() => {
          setShowModalEverydayTraining(false);
        }}
      >
        { widgetEverydayTraining }
      </Modal>
    </section>
  );
};
const English = (
  {
    widget100Words,
    widget60Phrases,
    widgetSubs,
    widgetA3M
  }
) => {
  const [showModal100Words, setShowModal100Words] = React.useState(false);
  const [showModal60Phrases, setShowModal60Phrases] = React.useState(false);
  const [showModalSubs, setShowModalSubs] = React.useState(false);
  const [showModalA3M, setShowModalA3M] = React.useState(false);
  return (
    <section className={`${offers.offers} ${offers.english}`} id="english">
      <div className="container">
        <h2>Английский язык</h2>
        <div className={offers.wrap}>
          <div
            className={offers.card}
            onClick={()=>{setShowModal100Words(true)}}
            onKeyDown={()=>{setShowModal100Words(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/english-100slov.png" alt=""/>
            <div className={offers.info}>
              <h3>100 английских слов для путешествий</h3>
              <p>Онлайн-курс для тех, кто хочет быстро запоминать иностранные слова</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModal60Phrases(true)}}
            onKeyDown={()=>{setShowModal60Phrases(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/english-60fraz.png" alt=""/>
            <div className={offers.info}>
              <h3>60 фраз для путешествий</h3>
              <p>Самые необходимые английский фразы для наиболее актуальных ситуаций в путешествии у вас в телефоне</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalSubs(true)}}
            onKeyDown={()=>{setShowModalSubs(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/english-subtitles.png" alt=""/>
            <div className={offers.info}>
              <h3>Субтитры к сериалам</h3>
              <p>Готовые транскрипты для скачивания внутри!</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
          <div
            className={offers.card}
            onClick={()=>{setShowModalA3M(true)}}
            onKeyDown={()=>{setShowModalA3M(true)}}
            role={"button"}
            tabIndex={-1}
          >
            <img src="https://fs.advance.ru/landing-pages/free/advance_free/english-a3m-2.png" alt=""/>
            <div className={offers.info}>
              <h3>Как выучить английский за 3 месяца с нуля до разговора</h3>
              <p>Бесплатный 5-дневный онлайн-марафон с Николаем Ягодкиным</p>
              <span>Получить бесплатно</span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModal100Words}
        onClose={() => {
          setShowModal100Words(false);
        }}
      >
        { widget100Words }
      </Modal>
      <Modal
        open={showModal60Phrases}
        onClose={() => {
          setShowModal60Phrases(false);
        }}
      >
        { widget60Phrases }
      </Modal>
      <Modal
        open={showModalSubs}
        onClose={() => {
          setShowModalSubs(false);
        }}
      >
        { widgetSubs }
      </Modal>
      <Modal
        open={showModalA3M}
        onClose={() => {
          setShowModalA3M(false);
        }}
      >
        { widgetA3M }
      </Modal>
    </section>
  );
};
const TITLE = 'Материалы для успешного обучения и мотивации';
const DESCRIPTION = 'Набор бесплатных обучающих материалов для детей, взрослых и по английскому языку';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1Top/>
      <Teens
        widgetVocabulary={<GetCourseWidget hash={'c7d7d48b02559fd6f0b4a28bba416c8939d1442d'} id={'704990'}/>}
        widgetGrammar={<GetCourseWidget hash={'8fb1d926d5023e253900acff036e8ff00baaed4a'} id={'705000'}/>}
        widgetMarathon={<GetCourseWidget hash={'d6b524ef5dc13ff222f98cf8b7aaa807c934a997'} id={'705075'}/>}
      />
      <Adults
        widgetWorkout={<GetCourseWidget hash={'2541f32e0014dab3c285facd863b85199dd33f67'} id={'705049'}/>}
        widgetMnemo={<GetCourseWidget hash={'908532ac7baac82af6d6517dc6ef9866e4ae31af'} id={'705040'}/>}
        widgetSmart={<GetCourseWidget hash={'d8bf53e44d9cd5345bd14200f979549d7a23acc8'} id={'705042'}/>}
        widgetMarathon={<GetCourseWidget hash={'cb4aa16f61595ea225552a1021bfc04089c386cd'} id={'705060'}/>}
        widgetEverydayTraining={<GetCourseWidget hash={'ed6879c1a91340ed2690b36aeb95aaf51f10c244'} id={'755893'}/>}
      />
      <English
        widget100Words={<GetCourseWidget hash={'73cc53889c3bc8d18e656c23f0ebddfe75db6d36'} id={'705196'}/>}
        widget60Phrases={<GetCourseWidget hash={'09c2947ab315e1b14a2fcc19c43314ecd9d3f3f6'} id={'705209'}/>}
        widgetSubs={<GetCourseWidget hash={'a6f68b4b4c969d9939c6d310a887423832790d21'} id={'705220'}/>}
        widgetA3M={<GetCourseWidget hash={'9383b0aab4c55f377063ce1aa3ded02c3aa1122d'} id={'705228'}/>}
      />
      <Screen1/>
      <Result/>
      <Info/>
      <Tech/>
      <School/>
      <Edu/>
      <Cases/>
      <VidReviews/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
